import type { ReactNode } from 'react'
import styles from './SiteHeader.module.css'

type TSiteHeaderProps = {
    variant: string
    showBorder: string
    logo: ReactNode
    navigation: ReactNode
    actions: ReactNode
}

export const SiteHeader = ({
    variant,
    showBorder,
    logo,
    navigation,
    actions,
}: TSiteHeaderProps) => (
    <header className={styles.header} data-variant={variant} data-show-border={showBorder}>
        <div className={styles.left}>
            {logo}
            {navigation}
        </div>
        {actions}
    </header>
)
